module.exports = __webpack_public_path__ + "static/media/lightPinkBrain.fd655b45.png";